import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import { Chip, Paper, Stack, Typography } from "@mui/material";
import Body from "../components/layout/Body";
import PatientAssistantHomeSidebar from "../components/ai/PatientAssistantHomeSidebar";

const PatientAssistantHomePage = () => {
    return (
        <Body
            sideBar={<PatientAssistantHomeSidebar />}
            mainElement={(
                <Stack spacing={3}>
                    <Stack spacing={0.5}>
                        <Typography variant="h4" fontWeight="bold">Assistente AI</Typography>
                        <Typography variant="body2" sx={{ opacity: 0.72 }}>
                            Scegli un paziente dalla sidebar per aprire l&apos;assistente AI dedicato ai suoi file.
                        </Typography>
                    </Stack>

                    <Chip
                        icon={<AutoAwesomeOutlinedIcon />}
                        label="Seleziona un paziente per continuare"
                        sx={{ alignSelf: 'start' }}
                    />

                    <Paper variant="outlined" sx={{ p: 3, borderStyle: 'dashed' }}>
                        <Stack spacing={1.5}>
                            <Typography variant="h5" fontWeight="bold">Hub Assistente AI</Typography>
                            <Typography variant="body1">
                                La configurazione dei job AI resta invariata: da qui scegli solo il paziente su cui lavorare.
                            </Typography>
                            <Typography variant="body2" sx={{ opacity: 0.72 }}>
                                Dopo il click entrerai nella pagina attuale dell&apos;assistente AI del paziente selezionato.
                            </Typography>
                        </Stack>
                    </Paper>
                </Stack>
            )}
        />
    );
};

export default PatientAssistantHomePage;
